module.exports = __webpack_public_path__ + "img/font.48a7b375.svg";